import { render, staticRenderFns } from "./PropertyFormDialog.vue?vue&type=template&id=2d88bb18&"
import script from "./PropertyFormDialog.vue?vue&type=script&lang=js&"
export * from "./PropertyFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports